import React, { useState } from "react";
import { Container, Nav, Navbar, NavDropdown, Row } from "react-bootstrap";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import "./HeaderFooter.css";
import Logo from "../../images/HospitalLogo.svg";
import useAuthService from "../../session/useAuthService";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useDispatch } from "react-redux";
import { resetState } from "../../RTK/middleware";
import { Avatar, List, message, Popover } from "antd";

export const HostpitalHeader = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const getActiveClass = (path) => (location.pathname === path ? "active" : "");

  const handleLogout = () => {
    setOpen(false);

    messageApi.open({
      type: "success",
      content: "Log Out Successfully",
      duration: 1,
      className: "ant-alert",
      onClose: () => {
        useAuthService.removeAuth();
        dispatch(resetState());
        navigate("/login");
      },
    });
  };

  const viewProfile = () => {
    setOpen(false);
    navigate("/clinic/viewProfile", {
      state: { hospitalId: useAuthService.getAuthId() } },
    );
  };

  const content = (
    <List
      className="cursor-pointer"
      bordered
      dataSource={[
        {
          text: "View Profile",
          icon: (
            <Icon
              icon="basil:user-solid"
              width="24"
              height="24"
              style={{ color: "#0D224E" }}
            />
          ),
          action: viewProfile,
        },
        {
          text: "Log out",
          icon: <Icon icon="solar:logout-outline" width="24" height="24" />,
          action: handleLogout,
        },
      ]}
      renderItem={(item) => (
        <List.Item className="custom-popper-item" onClick={item.action}>
          {item.icon} <span>{item.text}</span>
        </List.Item>
      )}
    />
  );

  // const hide = () => {
  //   setOpen(false);
  // };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  return (
    <>
      <Navbar className="nav-bg ">
        {contextHolder}
        <Container>
          <Navbar.Brand>
            <img src={Logo} alt="Logo.png" />
          </Navbar.Brand>
          <Nav className="me-auto ">
            <Nav.Link
              className={`text-white ${getActiveClass("/clinic/providers")}`}
              as={Link}
              to="/clinic/providers"
            >
              Provider List
            </Nav.Link>
            <Nav.Link
              className={`text-white ${getActiveClass(
                "/clinic/blockedProviders"
              )}`}
              as={Link}
              to="/clinic/blockedProviders"
            >
              Blocked Providers
            </Nav.Link>
          </Nav>
          <Nav className="justify-content-end">
            <Popover
              className={`cursor-pointer profile-popper ${
                open ? "profile-popper-active" : ""
              }`}
              content={content}
              title="Profile"
              placement="bottomRight"
              trigger="click"
              open={open}
              onOpenChange={handleOpenChange}
            >
              <Avatar
                size="small"
                style={{ backgroundColor: "white", verticalAlign: "middle" }}
                icon={
                  <Icon
                    icon="basil:user-solid"
                    width="24"
                    height="24"
                    style={{ color: "#0D224E" }}
                  />
                }
              />
              &ensp; {useAuthService.getName() ?? "Provider"}
            </Popover>
            {/* <NavDropdown
              title={useAuthService.getName() ?? "Clinic"}
              id="hospital-nav-dropdown"
              // data-bs-theme="light"
            >
              <NavDropdown.Item onClick={() => handleLogout()}>
                LogOut{" "}
                <Icon icon="solar:logout-outline" width="24" height="24" />
              </NavDropdown.Item>
            </NavDropdown> */}
          </Nav>
        </Container>
      </Navbar>
      <Row className="content">
        <Outlet />
      </Row>
      <footer className="nav-bg text-white py-3">
        <Container>
          <img src={Logo} alt="Logo.png" />
        </Container>
      </footer>
    </>
  );
};
